export default "__VITE_ASSET__CAlB1f7I__"